/**
 * Consultation Choice Modal
 *
 * Opens a modal with First Time Visit / Second Opinion options
 * when Schedule Free Consultation CTAs are clicked.
 *
 * @package WPS_Dental_Theme
 */

export class ConsultChoiceModal {
  constructor() {
    this.modal = document.getElementById("wps-consult-choice-modal");
    if (!this.modal) return;

    this.overlay = this.modal.querySelector(".wps-consult-choice-modal__overlay");
    this.closeBtn = this.modal.querySelector(".wps-consult-choice-modal__close");
    this.activeClass = "wps-consult-choice-modal--active";

    this.bindTriggers();
    this.bindClose();
  }

  bindTriggers() {
    const triggers = document.querySelectorAll(
      "a.js-consult-choice-trigger, a[href*='schedule-free-consultation'], .footer-sticky-menu .navbar-cta__container a",
    );

    triggers.forEach((trigger) => {
      if (trigger.closest("#wps-consult-choice-modal")) {
        return;
      }

      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        this.open();
      });
    });
  }

  bindClose() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", () => this.close());
    }

    if (this.overlay) {
      this.overlay.addEventListener("click", () => this.close());
    }

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && this.modal.classList.contains(this.activeClass)) {
        this.close();
      }
    });
  }

  open() {
    const fullScreenMenu = document.querySelector(".wps-full-screen-menu__wrapper");

    if (fullScreenMenu?.classList.contains("active")) {
      const closeBtn = document.querySelector(".close-btn");
      if (closeBtn) {
        closeBtn.click();
      } else {
        fullScreenMenu.classList.remove("active");
        document.body.classList.remove("add-bg-color");
        document.body.style.overflow = "";
      }
    }

    this.modal.classList.add(this.activeClass);
    this.modal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  close() {
    this.modal.classList.remove(this.activeClass);
    this.modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }
}
